<template>
	<div class="base-setting-box">
		<!-- <div class="flag-wrap">1688商品信息</div> -->
		<div class="form-box">
			<!--新增行政区域-->
			<el-dialog
				title="运费模版"
				:visible.sync="isShowFreight"
				width="720px"
				:isComponent="true"
				:before-close="hideFreight"
			>
				<div class="addTempladeName">
					<span>模版名称:</span>
					<el-input
						placeholder="请输入模版名称"
						size="mini"
						maxlength="32"
						v-model="name"
						style="width: 572px"
						show-word-limit
					></el-input>
				</div>
				<div class="addTempladeName">
					<span>模版描述:</span>
					<el-input
						placeholder="请输入模版描述"
						size="mini"
						maxlength="64"
						v-model="describe"
						style="width: 572px"
						show-word-limit
					></el-input>
				</div>

				<el-table
					:data="regionData"
					style="width: 88%; margin: 20px"
					max-height="600"
					:cell-style="tc"
					:header-cell-style="tccolor"
					type="index"
				>
					<el-table-column label="运送区域">
						<template slot-scope="scope">
							{{ scope.row.area }}
						</template>
					</el-table-column>
					<el-table-column label="是否包邮">
						<template slot-scope="scope">
							<el-select
								v-model="scope.row.is_free_freight"
								size="mini"
								placeholder="请选择是否包邮"
							>
								<el-option value="0" label="包邮"></el-option>
								<el-option value="5" label="不包邮"></el-option>
								<el-option value="10" label="不发货"></el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column label="当前区域增收运费比">
						<template slot-scope="scope">
							<el-input
								type="number"
								min="1"
								size="mini"
								v-model="scope.row.freight_rate"
							>
							</el-input>
						</template>
					</el-table-column>
				</el-table>
			</el-dialog>
			<el-form
				:model="form"
				:rules="rules"
				ref="form"
				label-width="140px"
				style="text-align: left"
			>
				<div class="flag-container">
					<el-form-item label="商品分类：" prop="parent_id">
						<el-select
							style="width: 170px; margin-right: 10px"
							v-model="form.parent_id"
							@change="classifyChange"
							placeholder="一级分类"
						>
							<el-option
								v-for="(item, index) in classifyList"
								:key="index"
								:label="item.name"
								:value="item.id"
							></el-option
						></el-select>
						<el-select
							style="width: 170px"
							v-model="form.cate_id"
							placeholder="二级分类"
						>
							<el-option
								v-for="(item, index) in sonClassifyList"
								:key="index"
								:label="item.name"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<div class="flag-wrap">基本信息</div>
				</div>
				<el-form-item label="商品名称：" prop="title">
					<el-input
						style="width: 350px"
						v-model="form.title"
						placeholder="输入商品名称"
					/>
				</el-form-item>
				<el-form-item label="副标题：" prop="sub_title">
					<el-input
						style="width: 350px"
						v-model="form.sub_title"
						placeholder="输入商品副标题"
					/>
				</el-form-item>
				<el-form-item label="商品来源：" prop="supply_id">
					<!-- <el-select
						v-model="form.supply_id"
						style="width:350px;"
						placeholder="请选择来源"
					>
						<el-option
							v-for="(item, index) in sourceList"
							:key="index"
							:label="item.name"
							:value="item.id"
						></el-option
					></el-select> -->
					<el-autocomplete
						popper-class="my-autocomplete"
						v-model="AutoVal"
						style="width: 350px"
						:fetch-suggestions="querySearch"
						placeholder="请输入内容"
						@select="handleSelect"
						:disabled="readSwitch"
					>
						<template slot-scope="{ item }">
							<div class="name">{{ item.name }}</div>
						</template>
					</el-autocomplete>
				</el-form-item>
				<el-form-item label="供应链商品ID：" prop="supply_product_no">
					<el-input
						style="width: 350px"
						v-model="form.supply_product_no"
						placeholder="请输入内容"
						:disabled="readSwitch"
					/>
				</el-form-item>
				<el-form-item label="基础运费：" prop="default_carriage">
					<el-input
						style="width: 350px"
						placeholder="请输入基础运费"
						v-model="form.default_carriage"
						:min="0"
						type="number"
						:disabled="readSwitch"
					>
						<template slot="append">元</template>
					</el-input>
				</el-form-item>
				<el-form-item
					v-if="form.freight_status == 2 || form.id == ''"
					label="运费模版："
					prop="freight_template_id"
				>
					<el-select
						style="width: 170px; margin-right: 10px"
						v-model="form.freight_template_id"
						collapse-tags
						placeholder="运费模版"
					>
						<el-option
							v-for="(item, index) in freghtList"
							:key="index"
							:label="item.name"
							:value="item.id"
						></el-option
					></el-select>
					<el-button type="primary" @click="showFreight">显示详情</el-button>
				</el-form-item>
				<el-form-item v-else label="运费模版：" prop="freight_name">
					<el-input
						style="width: 350px; margin-right: 10px"
						placeholder="请选择运费模版"
						v-model="form.freight_name"
						readonly
					>
					</el-input>
					<el-button type="primary" @click="showFreight">显示详情</el-button>
				</el-form-item>
				<!-- <el-form-item label="库存预警值：" prop="default_carriage">
					<el-input
						style="width:350px;"
						placeholder="请输入库存预警"
						v-model="form.default_carriage"
					>
					</el-input>
				</el-form-item> -->
				<div class="flag-container">
					<el-form-item label="计量单位：" prop="unit">
						<el-input
							style="width: 350px"
							placeholder="请输入计量单位"
							v-model="form.unit"
						>
						</el-input>
					</el-form-item>
					<div class="flag-wrap">参数信息</div>
				</div>
				<el-form-item label="商品重量：" prop="weight">
					<el-input
						style="width: 350px"
						placeholder="请输入商品重量"
						v-model="form.weight"
					>
						<el-select
							v-model="form.weight_unit"
							style="width: 90px"
							slot="append"
						>
							<el-option label="克" value="克"></el-option>
							<el-option label="千克" value="千克"></el-option>
						</el-select>
					</el-input>
				</el-form-item>
				<div class="flag-container">
					<el-form-item label="同步覆盖：" prop="auto_sync">
						<el-switch
							:active-value="1"
							:inactive-value="0"
							v-model="form.auto_sync"
							active-color="#13ce66"
						>
						</el-switch>
						<p style="color: #aaa; line-height: 0">
							如果设置为同步覆盖，则在供应链商品同步时以同步后数据在准
						</p>
					</el-form-item>
					<div class="flag-wrap">其他信息</div>
				</div>
				<el-form-item label="商品上架：" prop="status">
					<el-switch
						:active-value="1"
						:inactive-value="0"
						v-model="form.status"
						active-color="#13ce66"
					>
					</el-switch>
					<p style="color: #aaa; line-height: 0">
						如果为预售商品，请选择关闭上架，上架即代表可正常销售
					</p>
				</el-form-item>
				<el-form-item label="商品推荐：" prop="is_recommend">
					<el-switch
						:active-value="1"
						:inactive-value="0"
						v-model="form.is_recommend"
						active-color="#13ce66"
					>
					</el-switch>
					<p style="color: #aaa; line-height: 0">推荐该商品</p>
				</el-form-item>
				<el-form-item label="服务保证：">
					<el-checkbox
						label="无忧退货"
						v-model="form.worry_free_refund"
						:true-label="1"
						:false-label="0"
					></el-checkbox>
					<el-checkbox
						label="免费包邮"
						v-model="form.free_carriage"
						:true-label="1"
						:false-label="0"
					></el-checkbox>
					<el-checkbox
						label="正品保障"
						v-model="form.certified_product"
						:true-label="1"
						:false-label="0"
					></el-checkbox>
				</el-form-item>
				<!-- <el-form-item label="商品关键词：" prop="default_carriage">
					<el-input
						style="width:350px;"
						placeholder="请输入商品关键词"
						v-model="form.default_carriage"
					>
					</el-input>
					<p style="color:#aaa;width:450px;line-height:1.2">
						商品关键词请用空格分隔；有两个功能，一是可以作为站内关键词查询，在搜索框输入关键词后，能够搜索到该商品；二是提供下游渠道收录使用.
					</p>
				</el-form-item> -->
				<el-form-item label="商品备注：" prop="remark">
					<el-input
						style="width: 350px"
						type="textarea"
						placeholder="请输入内容"
						v-model="form.remark"
					>
					</el-input>
				</el-form-item>
				<div v-if="goodsData && goodsData.alibaba_product">
					<div class="flag-container">
						<el-form-item label="1688商品名称：">
							<span>{{ goodsData.alibaba_product.subject || '' }}</span>
						</el-form-item>
						<div class="flag-wrap">1688商品信息</div>
					</div>
					<el-form-item label="1688商品分类：">
						<span>{{ goodsData.alibaba_product.category_name || '' }}</span>
					</el-form-item>
					<el-form-item label="1688活动时间：">
						<span
							>{{ goodsData.alibaba_product.activity_start_time }} -
							{{ goodsData.alibaba_product.activity_end_time }}</span
						>
					</el-form-item>
					<el-form-item label="1688建议售价：">
						<span>¥{{ goodsData.alibaba_product.retailprice || '0.00' }}</span>
					</el-form-item>
					<el-form-item label="基础快递费：">
						<span
							>¥{{ goodsData.alibaba_product.default_carriage || '0.00' }}</span
						>
					</el-form-item>
					<el-form-item label="均摊快递费：">
						<span>¥{{ goodsData.alibaba_product.avg_carriage || '0.00' }}</span>
					</el-form-item>
					<div
						class="flag-container"
						v-if="
							goodsData.alibaba_product.price_ranges &&
								goodsData.alibaba_product.price_ranges.length
						"
					>
						<div class="table-wrap">
							<table
								border="1px"
								cellspacing="0"
								cellpadding="0"
								class="cus-table"
								wid
								:style="{
									width: `${120 *
										(goodsData.alibaba_product.price_ranges.length + 1)}px`
								}"
							>
								<tr class="row" align="center">
									<td class="col" align="center">参考价格</td>
									<td
										class="col"
										align="center"
										v-for="(item, index) in goodsData.alibaba_product
											.price_ranges"
										:key="index"
									>
										¥ {{ item.price }}
									</td>
								</tr>
								<tr class="row" align="center">
									<td class="col" align="center">起批量</td>
									<td
										class="col"
										align="center"
										v-for="(item, index) in goodsData.alibaba_product
											.price_ranges"
										:key="index"
									>
										{{ item.startQuantity }}件
									</td>
								</tr>
							</table>
						</div>

						<div class="flag-wrap">1688商品阶梯价</div>
					</div>
				</div>
			</el-form>
		</div>
	</div>
</template>
<script>
import {
	productCategoryGet,
	supplyChannel,
	freightTemplateDetailData,
	freightTemplateShow,
	freightRegionGroups
} from '@/api/goods'
export default {
	props: {
		goodsData: {},
		formData: {}
	},
	watch: {
		goodsData(v) {
			this.form = {
				parent_id: v.cate
					? v.cate.parent_cate
						? v.cate.parent_cate.id
						: v.cate.id
					: '',
				cate_id: v.cate ? (v.cate.parent_cate ? v.cate.id : '') : '',
				freight_template_id: v.freight_template_id ? v.freight_template_id : '',
				freight_name: v.freight_name ? v.freight_name : '',
				freight_status: v.freight_status ? v.freight_status : 0,
				title: v.title,
				sub_title: v.sub_title,
				supply_id: v.supply_id,
				supply_product_no: v.supply_product_no,
				default_carriage: v.default_carriage,
				unit: v.unit,
				weight: v.weight,
				weight_unit: v.weight_unit,
				auto_sync: v.auto_sync,
				status: v.status === 2 ? 0 : 1,
				is_recommend: v.is_recommend,
				worry_free_refund: v.service_promise[0],
				free_carriage: v.service_promise[1],
				certified_product: v.service_promise[2],
				remark: v.remark,
				id: v.id
			}
			this.AutoVal = v.supply_name
			this.productCategoryGetData(1)
			if (v.supplier_id > 0) {
				this.readSwitch = true
			}
		}
	},
	data() {
		return {
			readSwitch: false,
			classifyList: [],
			sonClassifyList: [],
			freghtList: [], // 运费模版列表
			sourceList: [],
			isShowFreight: false,
			regionData: [],
			name: '',
			describe: '',
			regionGroups: [],
			form: {
				parent_id: '',
				cate_id: '',
				freight_template_id: '',
				freight_status: 0,
				freight_name: '',
				title: '',
				sub_title: '',
				supply_id: '',
				supply_product_no: '',
				default_carriage: 0,
				unit: '',
				weight: '',
				weight_unit: '克',
				auto_sync: 1,
				status: 1,
				is_recommend: 1,
				worry_free_refund: 0,
				free_carriage: 0,
				certified_product: 0,
				remark: '',
				id: ''
			},
			AutoVal: '',
			rules: {
				parent_id: {
					required: true,
					message: '请选择商品分类',
					trigger: 'blur'
				},
				title: { required: true, message: '请输入商品名称', trigger: 'blur' },
				supply_id: {
					required: true,
					message: '请选择商品来源',
					trigger: 'blur'
				},
				supply_product_no: {
					required: true,
					message: '请输入供应链商品ID',
					trigger: 'blur'
				}
			}
		}
	},
	created() {
		this.productCategoryGetData(0)
		this.supplyChannelListData()
		this.getFreightTemplate()
		this.getfreightRegionGroupsData()
		console.log(this.goodsData)
	},
	methods: {
		querySearch(queryString, cb) {
			var restaurants = this.sourceList
			var results = queryString
				? restaurants.filter(this.createFilter(queryString))
				: restaurants
			// 调用 callback 返回建议列表的数据
			console.log(results)
			cb(results)
		},
		createFilter(queryString) {
			return sourceList => {
				return (
					sourceList.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
				)
			}
		},
		handleSelect(item) {
			console.log(item)
			this.form.supply_id = item.id
			this.AutoVal = item.name
		},
		showFreight() {
			let id = this.form.freight_template_id
			this.isShowFreight = true
			this.getfreightTemplateDetailData(id)
		},
		hideFreight() {
			this.regionData = []
			this.isShowFreight = false
		},
		//行政区域分组列表
		async getfreightRegionGroupsData() {
			let res = await freightRegionGroups()
			this.regionGroups = res
		},
		//获取模版详情
		async getfreightTemplateDetailData(id) {
			let res = await freightTemplateDetailData({ id: id })
			this.name = res.name
			this.describe = res.describe
			if (res.zone_config.length > 1) {
				var regionArr = []
				// console.log(res.zone_config)
				var ttconfig = res.zone_config
				for (var i = 0; i < ttconfig.length; i++) {
					var obj1 = ttconfig[i]
					var arr = [obj1]
					for (var j = i + 1; j < ttconfig.length; j++) {
						var obj2 = ttconfig[j]
						if (
							obj2.freight_type === obj1.freight_type &&
							obj2.freight_money === obj1.freight_money
						) {
							arr.push(obj2)
							ttconfig.splice(j, 1)
							j = j - 1
						}
					}
					regionArr.push(arr)
				}

				//  console.log(this.selectCityIds)

				regionArr.map(item => {
					var cityname = []
					var idArr = []
					var is_free_freight = String(item[0].freight_type)
					var freight_rate = String(item[0].freight_money)
					item.map(tt => {
						this.regionGroups.map(regionItem => {
							regionItem.areas.map(cc => {
								if (cc.id == tt.region_id) {
									cityname.push(cc.name)
									idArr.push(cc.id)
									return
								}
							})
						})
					})
					this.regionData.push({
						region_ids: idArr,
						is_free_freight: is_free_freight,
						freight_rate: freight_rate,
						area: cityname.join(',')
					})
				})
				this.isShowFreight = true
			} else if (res.zone_config.length == 1) {
				var cityename = ''
				this.regionGroups.map(regionItem => {
					regionItem.areas.map(cc => {
						if (cc.id == res.zone_config[0].region_id) {
							cityename = cc.name
							return
						}
					})
				})
				this.regionData.push({
					region_ids: [res.zone_config[0].region_id],
					is_free_freight: String(res.zone_config[0].freight_type),
					freight_rate: String(res.zone_config[0].freight_money),
					area: cityename
				})
				this.isShowFreight = true
			}
		},
		clearForm() {
			this.$refs.form.resetFields()
		},
		checkForm() {
			console.log(this.form)
			this.$refs.form.validate(valid => {
				if (valid) {
					this.$emit('update:formData', this.form)
					this.$emit('on-success')
				} else {
					return false
				}
			})
		},
		//根据一级分类改变
		classifyChange(id) {
			if (!id) {
				this.sonClassifyList = []
				this.form.cate_id = ''
				return
			}
			this.form.parent_id = id
			this.productCategoryGetData(1)
		},
		//获取商品来源
		supplyChannelListData() {
			supplyChannel({
				name: '',
				page: 1,
				size: 1000
			}).then(res => {
				this.sourceList = res.data
			})
		},
		//获取商品分类
		productCategoryGetData(type) {
			productCategoryGet({
				name: '',
				page: 1,
				page_size: 100,
				parent_id: this.form.parent_id,
				status: ''
			}).then(res => {
				console.log(res)
				this.form.supply_id
				if (type == 1) {
					this.sonClassifyList = res.data
					if (!res.data.length) {
						this.form.cate_id = ''
					}
				} else {
					this.classifyList = res.data
				}
			})
		},
		//获取运费模版信息
		getFreightTemplate() {
			freightTemplateShow({}).then(res => {
				this.freghtList = res
			})
		},
		tc() {
			return 'text-align:center; color:#333333; font-size:12px;'
		},
		tccolor() {
			return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
		}
	}
}
</script>
<style lang="scss" scoped>
@import 'src/styles/mixin.scss';
.base-setting-box {
	border: 1px solid #ddd;
	width: 1100px;
	margin: 0 auto;
	padding-left: 180px;
	background-color: #fcfcfc;
	.addTempladeName {
		margin: 20px;
		span {
			font-size: 13px;
			margin-right: 8px;
			color: #666666;
		}
	}
	.flag-container {
		position: relative;
		.flag-wrap {
			$h: 48px;
			width: 180px;
			height: $h;
			background-color: #9ea7b4;
			position: absolute;
			left: -271px;
			top: 0;
			color: #fff;
			font-size: 16px;
			display: flex;
			align-items: center;
			padding-left: 42px;
			&::before {
				content: '';
				position: absolute;
				width: 0;
				height: 0;
				border-top: 12px solid #fff;
				border-bottom: 6px solid transparent;
				border-left: 8px solid #fff;
				border-right: 8px solid #fff;
				top: 50%;
				transform: translateY(-50%);
				left: 20px;
			}
			&::after {
				content: '';
				position: absolute;
				width: 0;
				height: 0;
				top: 0;
				right: -$h/3;
				border-top: $h/2 solid transparent;
				border-bottom: $h/2 solid transparent;
				border-left: $h/3 solid #9ea7b4;
			}
		}
	}

	.form-box {
		border-left: 1px solid #ddd;
		background-color: #fff;
		padding-left: 90px;
		padding-top: 40px;
		padding-bottom: 20px;
		.table-wrap {
			overflow-x: auto;
			.cus-table {
				border-color: #ccc;
				border-collapse: collapse;
				border-spacing: 0;
				.row {
					height: 40px;
					.col {
						width: 120px;
						&:first-child {
							background-color: #f2f2f2;
						}
					}
				}
			}
		}
	}
}
</style>
